module.exports = __webpack_public_path__ + "img/maintenance.30bd08cb.svg";